var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-8pf3ei" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  gap: 8px;\n"])));
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-17yda3z" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  text-align: center;\n  margin: 0;\n"], ["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  text-align: center;\n  margin: 0;\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-180685s" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n  max-width: 633px;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n  max-width: 633px;\n  margin: 0;\n"])));
var UsingDescription = function (_a) {
    var rest = __rest(_a, []);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Title, { children: "Request and Download" }, void 0), _jsx(Text, { children: "It typically takes 1-2 minutes to generate a PDF file. While the report is in progress, you can leave and return later. To see the PDF, please make sure to refresh the page. Note that the duration may vary based on your class's data." }, void 0)] }), void 0));
};
export { UsingDescription };
var templateObject_1, templateObject_2, templateObject_3;
